import MiniHero from "../components/hero/MiniHero";
import AllBlogArea from "../components/blogs/AllBlogs";
import { blogs } from "./Home";



const Blog = () => {

    return (
        <div>
            <MiniHero text={"Nos Articles"} url={"/assets/img/theme/mini4.jpg"}/>
            <AllBlogArea items={blogs}/>
        </div>
    );
};

export default Blog;

